// utility functions for SelectList for handling the complexity of nested attributes
import { isNil } from '../../lib/utils';

export function findOptionById(options = [], value, valueKey, nestedKey) {
  let option;

  if (value) {
    for (let i = 0; i < options.length; i++) {
      if (options[i] === value || options[i][valueKey] === value) {
        return options[i];
      }
      if (nestedKey && (option = findOptionById(options[i][nestedKey], value, valueKey, nestedKey))) {
        return option;
      }
    }
  }
  return option;
}

export function findOptionByKey(options = [], key, nestedKey) {
  const indexes = key.split('.').map(k => parseInt(k, 10));
  let item;

  for (let i = 0; i <= indexes.length - 1; i++) {
    item = options[indexes[i]];
    options = item[nestedKey]; // eslint-disable-line no-param-reassign
  }
  return item;
}

export function filterOptions(options = [], input = '', labelKey, nestedKey) {
  const newOptions = [];

  options.forEach(option => {
    const label = typeof option === 'string' ? option : option[labelKey];
    const foundInChildren = nestedKey && filterOptions(option[nestedKey], input, labelKey, nestedKey);
    const found = foundInChildren && foundInChildren.length;

    if (label.toLowerCase().indexOf(input) >= 0 || found) {
      newOptions.push(found ? { ...option } : option);
    }
    if (found) {
      newOptions[newOptions.length - 1][nestedKey] = foundInChildren;
    }
  });
  return newOptions;
}

export function flatten(options = [], rootKey, level, nestedKey, nestedKeySelectable, labelKey, valueKey) {
  let items = [];

  options.forEach((option, index) => {
    const key = `${rootKey}${rootKey ? '.' : ''}${index}`;
    const selectable = nestedKeySelectable ? !option[nestedKeySelectable] : false;

    items.push({ option, key, level, selectable });
    items = items.concat(flatten(option[nestedKey], key, level + 1, nestedKey, nestedKeySelectable, labelKey, valueKey));
  });
  return items;
}

export const valueEqualsOption = ({ option, value, valueKey = 'value' }) => {
  if (!isNil(value) && !isNil(option[valueKey])) {
    return (value === option[valueKey]) || (!isNil(value[valueKey]) && (value[valueKey] === option[valueKey]));
  } else {
    return !isNil(value) && option === value
  }
}
